import { ArrowLeftRight } from "lucide-react";

interface Props {
  termA: string;
  termB: string;
  explanation: string;
}

export default function VocabContrastCard({ termA, termB, explanation }: Props) {
  return (
    <div className="relative overflow-hidden rounded-xl border border-[hsl(15_75%_60%/0.28)] bg-gradient-to-r from-[hsl(225_60%_20%/0.5)] via-card/45 to-[hsl(15_60%_20%/0.45)] p-4 shadow-[0_0_28px_-14px_hsl(15_85%_55%/0.5)]">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-[hsl(225_90%_70%/0.6)] via-[hsl(280_85%_70%/0.6)] to-[hsl(15_90%_65%/0.7)]" />
      <div className="flex items-center gap-2 mb-3">
        <div className="flex h-6 w-6 items-center justify-center rounded-md bg-[hsl(280_60%_45%/0.22)] ring-1 ring-[hsl(280_85%_65%/0.4)]">
          <ArrowLeftRight className="h-3.5 w-3.5 text-[hsl(280_90%_80%)]" />
        </div>
        <span className="text-[10px] font-heading font-semibold uppercase tracking-[0.18em] text-[hsl(280_80%_82%)]">
          Concept Contrast
        </span>
      </div>
      <div className="flex items-center justify-center gap-3 mb-3">
        <span className="rounded-lg border border-[hsl(225_80%_65%/0.35)] bg-[hsl(225_70%_45%/0.18)] px-3 py-1.5 text-sm font-heading font-bold text-[hsl(225_90%_85%)] shadow-[0_0_18px_-8px_hsl(225_85%_60%/0.7)]">
          {termA}
        </span>
        <span className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground font-heading">vs</span>
        <span className="rounded-lg border border-[hsl(15_85%_62%/0.4)] bg-[hsl(15_75%_45%/0.22)] px-3 py-1.5 text-sm font-heading font-bold text-[hsl(15_95%_82%)] shadow-[0_0_18px_-8px_hsl(15_90%_60%/0.75)]">
          {termB}
        </span>
      </div>
      <p className="font-body text-sm leading-relaxed text-foreground/80">{explanation}</p>
    </div>
  );
}
